import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiListItemIcon = {
  styleOverrides: {
    root: {
      color: 'inherit',
      fontSize: 'var(--icon-fontSize-md)',
      minWidth: 'auto',
    },
  },
} satisfies Components<Theme>['MuiListItemIcon'];
